<template>
  <v-btn
    :href="href"
    target="_blank"
    rel="noopener"
    :variant="variant"
    :size="size"
    color="indigo"
    prepend-icon="mdi-chat"
  >
    {{ $t('common.community') }}
  </v-btn>
</template>

<script>
import { Config } from '@/Config'

export default {
  name: 'DiscordButton',
  props: {
    href: {
      type: String,
      default: Config.links.discord
    },
    /** Placement of the link: the play page drops it next to its other secondary actions. */
    variant: {
      type: String,
      default: 'tonal'
    },
    size: {
      type: String,
      default: 'default'
    }
  }
}
</script>
